import { render } from "./EditWorkExperience.vue?vue&type=template&id=8f6be912"
import script from "./EditWorkExperience.vue?vue&type=script&lang=js"
export * from "./EditWorkExperience.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__